import { render, staticRenderFns } from "./_requests-v2.tab.vue?vue&type=template&id=22543f2a&scoped=true"
import script from "./_requests-v2.tab.vue?vue&type=script&lang=js"
export * from "./_requests-v2.tab.vue?vue&type=script&lang=js"
import style0 from "./_requests-v2.tab.vue?vue&type=style&index=0&id=22543f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22543f2a",
  null
  
)

export default component.exports